var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-container"},[_c('div',{staticClass:"circle",style:({ borderColor: _vm.borderColor })},[_c('div',{staticClass:"circle-text"},[_vm._v(_vm._s(_vm.innerValue + ' ' + _vm.complemento))])]),_c('div',{staticClass:"title-container"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }